
import './App.css';
import Temp from './components/weather/temp';
function App() {
  return (
   <>
   <Temp></Temp>
   </>
  );
}

export default App;
